import React from "react";
var __jsx = React.createElement;
var ContentBox = function ContentBox(_ref) {
  var children = _ref.children,
    id = _ref.id;
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: "flex flex-col gap-3 px-3 py-4 rounded border-gray-azureish border bg-white border-solid"
  }, children);
};
export default ContentBox;